import {CommentIcon} from '@primer/octicons-react'
import {ZeroState} from '../toolbar/ZeroState'

export function CommentsErrorFallback() {
  return (
    <div className="d-flex flex-column position-relative width-full height-full flex-justify-center">
      <ZeroState
        description="Try reloading the pull request page."
        heading="Unable to load comments"
        icon={CommentIcon}
        headingLevel="h2"
      />
    </div>
  )
}
